/**
 * 语音识别配置常量
 * 用于统一所有应用中的语音识别配置
 */

/**
 * 默认支持的语言列表
 * 包含所有应用需要支持的语言
 */
export const DEFAULT_AUTO_DETECT_LANGUAGES = [
  'en-US',
  'ja-JP',
  'zh-CN',
  'ko-KR',
  'vi-VN',
  'pt-PT',
  'pt-BR',
  'id-ID',
  'ne-NP',
  'es-ES',
  'my-MM',
] as const;

/**
 * 短语列表配置
 * 用于提高特定词汇的识别准确性
 */
export const SPEECH_PHRASE_LIST = [
  'Sparticle',
  'GBase',
  'GBase Support',
  'GBase Knowledge',
  'Felo Subtitles',
  'Gina',
  'ジービーちゃん',
  '吉娜',
  'やさいのようせい',
] as const;

/**
 * 语言代码映射表
 * 将简短的语言代码转换为完整的语言标识符
 */
export const LANGUAGE_CODE_MAPPING = {
  ja: 'ja-JP',
  zh: 'zh-CN',
  ko: 'ko-KR',
  en: 'en-US',
  vi: 'vi-VN',
  pt: 'pt-PT',
  'pt-BR': 'pt-BR',
  id: 'id-ID',
  ne: 'ne-NP',
  es: 'es-ES',
  my: 'my-MM',
} as const;

/**
 * 默认语音配置
 */
export const DEFAULT_SPEECH_CONFIG = {
  region: 'japaneast',
  postProcessingOption: 'TrueText',
  languageIdMode: 'Continuous',
} as const;
